import { gql } from "urql";

export const GET_ORDERS = gql`
  query Orders(
    $first: Int!
    $skip: Int!
    $placedAtGte: Int!
    $placedAtLte: Int!
    $merchantAcceptedAddr: String!
  ) {
    orders_collection(
      first: $first
      skip: $skip
      where: {
        placed_at_gte: $placedAtGte
        placed_at_lte: $placedAtLte
        merchant_accepted_addr: $merchantAcceptedAddr
      }
    ) {
      id
      order_id
      type
      status
      user_addr
      recipient_addr
      merchant_accepted_addr
      assigned_merchants
      amount
      inr_amount
      is_user_completed
      user_completed_at
      placed_at
      completed_at
    }
  }
`;

export const GET_ALL_ORDERS = gql`
  query Orders($first: Int!, $skip: Int!, $merchantAcceptedAddr: String!) {
    orders_collection(
      first: $first
      skip: $skip
      where: { merchant_accepted_addr: $merchantAcceptedAddr }
    ) {
      id
      order_id
      type
      status
      user_addr
      recipient_addr
      merchant_accepted_addr
      assigned_merchants
      amount
      inr_amount
      is_user_completed
      user_completed_at
      placed_at
      completed_at
    }
  }
`;
